export default __webpack_public_path__ + "static/media/papa.c32d6cb8.png";